/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable camelcase */
import React, { SyntheticEvent } from 'react';
import { debounce } from 'lodash';
import {
  TextField, Autocomplete,
} from '@mui/material/';

interface Props {
  label: string;
  autoCompleteOptions: any[];
  getPredictions: (input: string | undefined) => void;
  handleAddressSelection: (value: any) => void;
  placeholder?: string;
}

const AutoCompleteSearchField: React.FC<Props> = ({
  label,
  getPredictions,
  autoCompleteOptions,
  placeholder,
  handleAddressSelection,
}) => {
  const onChange = React.useCallback(
    debounce((val) => getPredictions(val), 100),
    [],
  );

  const handleSelectorChange = (event: SyntheticEvent<Element, Event>,
    value: any): void => {
    handleAddressSelection(value);
    getPredictions('');
  };
  return (
    <Autocomplete
      id="global-search-bar"
      data-testid="map-search-address"
      clearOnEscape
      options={autoCompleteOptions}
      noOptionsText="No results match the search criteria"
      getOptionLabel={(option) => option.description}
      onChange={handleSelectorChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          placeholder={placeholder}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          onKeyPress={(e) => e.key === 'Enter' && e.preventDefault()}
        />
      )}
    />
  );
};

export default AutoCompleteSearchField;
